import {
  ChevronLeft as ChevronLeftIcon,
  ChevronRight as ChevronRightIcon,
} from "@mui/icons-material";
import {
  Box,
  Fab,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Paper,
  Popper,
  Typography,
  useMediaQuery,
} from "@mui/material";
import axios from "axios";
import { useEffect, useMemo, useState } from "react";
import { Link as RouterLink, useLocation, useNavigate } from "react-router-dom";
import { getNewExperienceEnabled } from "../../utils/getNewExperienceEnabled";
import SideBarAccountSelector from "../dashboardComponents/sideBarAccountSelector";

const LEGACY_NAV_GROUPS = [
  {
    title: "Dashboards",
    items: [
      {
        label: "Growth Plan",
        path: "growth-plan",
        iconPath: "/nav-icons/SpaceDashboardFilled.svg",
      },
      {
        label: "Performance Review",
        path: "performance-review",
        iconPath: "/nav-icons/performance-review-icon.svg",
      },
      {
        label: "Lucro Metrics",
        path: "lucro-metrics",
        iconPath: "/nav-icons/IoStatsChart.svg",
      },
      {
        label: "Industry Insights",
        path: "industry-insights",
        iconPath: "/nav-icons/IoBusiness.svg",
      },
      // {
      //   label: "Analysis Dashboards",
      //   iconPath: "/analysis-dashboards-icon.svg",
      //   children: [
      //     {
      //       label: "Performance Review",
      //       path: "performance-review",
      //       iconPath: "/nav-icons/performance-review-icon.svg",
      //     },
      //     {
      //       label: "Lucro Metrics",
      //       path: "lucro-metrics",
      //       iconPath: "/nav-icons/IoStatsChart.svg",
      //     },
      //     {
      //       label: "Industry Insights",
      //       path: "industry-insights",
      //       iconPath: "/nav-icons/IoBusiness.svg",
      //     },
      //   ],
      // },
    ],
  },
  {
    title: "Tools",
    items: [
      { label: "Reports", path: "reports", iconPath: "/nav-icons/BsFileBarGraphFill.svg" },
      {
        label: "Bank Activity",
        path: "preview-bank-activity",
        iconPath: "/nav-icons/BsBank2.svg",
      },
      { label: "Targets", path: "targets", iconPath: "/nav-icons/MdOutlineRadar.svg" },
      {
        label: "Scenario Planner",
        path: "preview-scenario-planner",
        iconPath: "/nav-icons/MdOutlineCompare.svg",
      },
      {
        label: "Capacity Calculator",
        path: "preview-capacity-calculator",
        iconPath: "/nav-icons/IoCalculator.svg",
      },
      {
        label: "Vendor Breakdown",
        path: "vendor-analysis",
        iconPath: "/nav-icons/IoReceipt.svg",
      },
      // {
      //   label: "Resources",
      //   iconPath: "/resources-icon.svg",
      //   children: [
      //     { label: "The Vault", path: "vault", iconPath: "/nav-icons/MdSchool.svg" },
      //     {
      //       label: "Lucro Flow",
      //       path: "lucro-flow",
      //       iconPath: "/nav-icons/MdPublishedWithChanges.svg",
      //     },
      //   ],
      // },
    ],
  },
  {
    title: "Resources",
    items: [
      { label: "The Vault", path: "vault", iconPath: "/nav-icons/MdSchool.svg" },
      {
        label: "Lucro Flow",
        path: "lucro-flow",
        iconPath: "/nav-icons/MdPublishedWithChanges.svg",
      },
      {
        label: "Lucro Insights",
        path: "preview-insights",
        iconPath: "/nav-icons/AI.svg",
      },
    ],
  },
];

const NEW_EXPERIENCE_NAV_GROUPS = [
  {
    title: "Dashboards",
    items: [
      {
        label: "Performance Overview",
        iconPath: "/nav-icons/SpaceDashboardFilled.svg",
        path: "performance-overview",
      },
      {
        label: "Lucro Metrics",
        iconPath: "/nav-icons/IoStatsChart.svg",
        path: "preview-lucro-metrics",
      },
      {
        label: "Industry Insights",
        iconPath: "/nav-icons/IoBusiness.svg",
        path: "preview-industry-insights",
      },
    ],
  },
  {
    title: "Tools",
    items: [
      { label: "Reports", path: "reports", iconPath: "/nav-icons/BsFileBarGraphFill.svg" },
      {
        label: "Bank Activity",
        path: "preview-bank-activity",
        iconPath: "/nav-icons/BsBank2.svg",
      },
      {
        label: "Targets",
        path: "preview-targets",
        iconPath: "/nav-icons/MdOutlineRadar.svg",
      },
      {
        label: "Scenario Planner",
        path: "preview-scenario-planner",
        iconPath: "/nav-icons/MdOutlineCompare.svg",
      },
      {
        label: "Capacity Calculator",
        path: "preview-capacity-calculator",
        iconPath: "/nav-icons/IoCalculator.svg",
      },
      {
        label: "Vendor Breakdown",
        path: "preview-vendor-breakdown",
        iconPath: "/nav-icons/IoReceipt.svg",
      },
    ],
  },
  {
    title: "Resources",
    items: [
      { label: "The Vault", path: "vault", iconPath: "/nav-icons/MdSchool.svg" },
      { label: "Lucro Flow", path: "preview-flow", iconPath: "/nav-icons/MdPublishedWithChanges.svg" },
      {
        label: "Lucro Insights",
        path: "preview-insights",
        iconPath: "/nav-icons/AI.svg",
      },
    ],
  },
];

const ADMIN_CUSTOMER_VIEW_NAV_GROUPS = [
  {
    title: "Internal Tools",
    items: [
      {
        label: "Profile Overview",
        path: "profile-overview",
        iconPath: "/nav-icons/SpaceDashboardFilled.svg",
      },
      {
        label: "Bank Activity",
        path: "bank-activity",
        iconPath: "/nav-icons/BsBank2.svg",
      },
      {
        label: "Targets",
        path: "saas-target",
        iconPath: "/nav-icons/MdOutlineRadar.svg",
      },
    ],
  },
  {
    title: "Client View",
    items: [
      {
        label: "Performance Overview",
        path: "performance-overview",
        iconPath: "/nav-icons/SpaceDashboardFilled.svg",
      },
      { label: "Reports", path: "reports", iconPath: "/nav-icons/BsFileBarGraphFill.svg" },
      { label: "The Vault", path: "vault", iconPath: "/nav-icons/MdSchool.svg" },
    ],
  },
];

const STAFF_OTHER_ITEMS_NEW = [
  { label: "Settings", iconPath: "/nav-icons/settings-icon.svg", path: "settings" },
  {
    label: "Go Back",
    iconPath: "/nav-icons/IoLogOutOutline.svg",
    path: "/management/accounts",
  },
];

const STAFF_OTHER_ITEMS_LEGACY = [
  { label: "Settings", iconPath: "/nav-icons/settings-icon.svg", path: "settings" },
  {
    label: "Go Back",
    iconPath: "/nav-icons/IoLogOutOutline.svg",
    path: null,
  },
];

const CLIENT_OTHER_ITEMS = [
  { label: "Tutorial", iconPath: "/nav-icons/GoPlay.svg", path: "tutorial" },
  { label: "Settings", iconPath: "/nav-icons/settings-icon.svg", path: "settings" },
  { label: "Log Out", iconPath: "/nav-icons/IoLogOutOutline.svg", path: "logout" },
];

const MODE_CONFIG = {
  STAFF_NEW: {
    navGroups: ADMIN_CUSTOMER_VIEW_NAV_GROUPS,
    otherItems: STAFF_OTHER_ITEMS_NEW,
  },
  STAFF_LEGACY: {
    navGroups: LEGACY_NAV_GROUPS,
    otherItems: STAFF_OTHER_ITEMS_LEGACY,
  },
  CLIENT_NEW: {
    navGroups: NEW_EXPERIENCE_NAV_GROUPS,
    otherItems: CLIENT_OTHER_ITEMS,
  },
  CLIENT_LEGACY: {
    navGroups: LEGACY_NAV_GROUPS,
    otherItems: CLIENT_OTHER_ITEMS,
  },
};

let hoverCloseTimeout = null;
const cancelClose = () => {
  if (hoverCloseTimeout) clearTimeout(hoverCloseTimeout);
};

const Sidebar = ({
  expanded: expandedProp,
  onToggle,
  customers = [],
  profile,
}) => {
  const location = useLocation();
  const isMobile = useMediaQuery("(max-width:1280px)", { noSsr: true });
  const isShortViewport = useMediaQuery("(max-height:820px)", { noSsr: true });
  const isVeryShortViewport = useMediaQuery("(max-height:720px)", {
    noSsr: true,
  });
  const [expandedState, setExpandedState] = useState(true);
  const [hoverAnchor, setHoverAnchor] = useState(null);
  const [hoverChildren, setHoverChildren] = useState([]);

  const [activeCustomer, setActiveCustomer] = useState(null);

  const staffView = profile?.type === "admin" || profile?.type === "accountant";
  const isAdmin = profile?.type === "admin";

  const newExperienceEnabled = useMemo(
    () => getNewExperienceEnabled(profile),
    [profile],
  );
  const selectedCustomerId = sessionStorage.getItem("selectedCustomerId");

  const clientRoute = useMemo(() => {
    const pathname = location?.pathname || "";
    const match = pathname.match(/^\/client\/([^/]+)(?:\/|$)/);
    return {
      isClientPath: Boolean(match),
      routeCustomerId: match?.[1] || null,
    };
  }, [location?.pathname]);

  // Staff mode is when staff are viewing a specific customer's dashboard.
  // Per requirement, determine this once and derive all nav behavior from it.
  const staffMode = staffView;

  const effectiveCustomerId = clientRoute.routeCustomerId || selectedCustomerId;

  useEffect(() => {
    if (!profile) return;
    if (!staffView) return;

    const storedId = sessionStorage.getItem("selectedCustomerId");
    const idToLoad = clientRoute.routeCustomerId || storedId;
    if (!idToLoad) return;

    // Avoid refetching on unrelated re-renders.
    if (activeCustomer?.id && String(activeCustomer.id) === String(idToLoad)) {
      return;
    }

    let cancelled = false;

    const fetchCustomer = async () => {
      try {
        const res = await axios.get(`/api/v2/customers/${idToLoad}/`, {
          headers: { "Content-Type": "application/json" },
          withCredentials: true,
        });
        if (!cancelled) setActiveCustomer(res.data);
      } catch (err) {
        if (!cancelled) console.error("Error fetching staff customer:", err);
      }
    };

    fetchCustomer();

    return () => {
      cancelled = true;
    };
  }, [activeCustomer?.id, clientRoute.routeCustomerId, profile?.id, staffView]);

  useEffect(() => {
    if (!profile) return;
    if (staffView) return;

    const storedId = sessionStorage.getItem("selectedCustomerId");
    const idToLoad = clientRoute.routeCustomerId || storedId;
    if (!idToLoad) return;

    const customer =
      customers.find((c) => c.id.toString() === idToLoad) ||
      customers[0] ||
      null;
    setActiveCustomer(customer);
  }, [clientRoute.routeCustomerId, customers, profile?.id, staffView]);

  useEffect(() => {
    if (!profile) return;

    const handleSelectedChange = async () => {
      const storedId = sessionStorage.getItem("selectedCustomerId");
      if (!storedId) return;

      if (staffView) {
        try {
          const res = await axios.get(`/api/v2/customers/${storedId}/`, {
            headers: { "Content-Type": "application/json" },
            withCredentials: true,
          });
          setActiveCustomer(res.data);
        } catch (err) {
          console.error("Error fetching staff customer:", err);
        }
        return;
      }

      const found = customers.find((c) => c.id.toString() === storedId);
      if (found) setActiveCustomer(found);
    };

    window.addEventListener("selectedCustomerId-changed", handleSelectedChange);
    return () => {
      window.removeEventListener(
        "selectedCustomerId-changed",
        handleSelectedChange,
      );
    };
  }, [profile, staffView, customers]);

  // When we hide the account selector in the new experience, we still need to
  // pick a default customer. Mirror the legacy selector logic: prefer the first
  // non-demo customer, but never override an explicit selection (including demo).
  useEffect(() => {
    if (!newExperienceEnabled) return;
    // Only applies to client users (staff choose customers via routes/selector)
    if (profile?.type !== "client") return;

    const profileCustomers = Array.isArray(customers) ? customers : [];
    if (profileCustomers.length === 0) return;

    const stored = sessionStorage.getItem("selectedCustomerId");
    const storedCustomer = stored
      ? profileCustomers.find((c) => c.id.toString() === stored)
      : null;

    if (storedCustomer) return;

    const chosenCustomer =
      profileCustomers.find((c) => !c.is_demo) || profileCustomers[0];
    if (!chosenCustomer?.id) return;

    sessionStorage.setItem("selectedCustomerId", chosenCustomer.id);
    localStorage.removeItem("dashboardDate");
    sessionStorage.setItem("adjustedView", JSON.stringify(false));

    window.dispatchEvent(new Event("dashboardDate-changed"));
    window.dispatchEvent(
      new CustomEvent("adjustedView-changed", { detail: false }),
    );
    window.dispatchEvent(new Event("selectedCustomerId-changed"));
  }, [newExperienceEnabled, customers, profile?.type]);

  const customersForSelector = useMemo(() => {
    const base = Array.isArray(customers) ? customers : [];

    // Only admins lack a pre-scoped customer list in the profile.
    if (profile?.type === "admin") {
      return activeCustomer ? [activeCustomer] : [];
    }

    // Non-admins (client/accountant/etc) should use profile.customers.
    if (activeCustomer?.id) {
      const exists = base.some(
        (c) => String(c?.id) === String(activeCustomer.id),
      );
      if (!exists) return [...base, activeCustomer];
    }

    return base;
  }, [activeCustomer, customers, profile?.type]);

  const modeKey = useMemo(() => {
    const audience = staffMode ? "STAFF" : "CLIENT";
    const experience = newExperienceEnabled ? "NEW" : "LEGACY";
    return `${audience}_${experience}`;
  }, [newExperienceEnabled, staffMode]);

  const modeConfig = useMemo(
    () => MODE_CONFIG[modeKey] || MODE_CONFIG.CLIENT_LEGACY,
    [modeKey],
  );

  const navGroups = modeConfig.navGroups;

  const navigate = useNavigate();

  useEffect(() => {
    if (activeCustomer?.is_demo && location.pathname.includes("targets")) {
      navigate("/");
    }
  }, [activeCustomer, location.pathname, navigate]);

  const OTHER_ITEMS = modeConfig.otherItems;

  const goBackTarget = useMemo(() => {
    if (!staffMode) return null;
    if (!newExperienceEnabled && effectiveCustomerId) {
      return `/client/${effectiveCustomerId}/`;
    }
    return "/management/accounts";
  }, [staffMode, newExperienceEnabled, effectiveCustomerId]);

  const expanded =
    typeof expandedProp === "boolean" ? expandedProp : expandedState;

  // Dynamic sizing so the sidenav fits smaller screens without scrolling.
  const density = useMemo(() => {
    if (isVeryShortViewport) return "tight";
    if (isShortViewport) return "compact";
    return "comfortable";
  }, [isShortViewport, isVeryShortViewport]);

  const navItemHeight = useMemo(() => {
    if (density === "tight") return 30;
    if (density === "compact") return 34;
    return 38;
  }, [newExperienceEnabled, density]);

  const navItemPx = useMemo(() => {
    if (!expanded) return 0;
    if (density === "tight") return "6px";
    if (density === "compact") return "7px";
    return "8px";
  }, [expanded, density]);

  const sectionPx = useMemo(() => {
    if (expanded)
      return density === "tight" ? 2 : density === "compact" ? 2.25 : 2.5;
    return density === "tight" ? 1 : density === "compact" ? 1.25 : 1.5;
  }, [expanded, density]);

  const sectionPy = useMemo(
    () => (density === "tight" ? 1.25 : density === "compact" ? 1.5 : 2),
    [density],
  );
  const groupMb = useMemo(
    () => (density === "tight" ? 1.5 : density === "compact" ? 2 : 3),
    [density],
  );
  const groupTitleFontSize = useMemo(
    () => (density === "tight" ? 12 : density === "compact" ? 13 : 14),
    [density],
  );
  const groupTitleMb = useMemo(
    () => (density === "tight" ? 0.5 : 1),
    [density],
  );
  const groupGap = useMemo(
    () =>
      density === "tight" ? "6px" : density === "compact" ? "8px" : "10px",
    [density],
  );
  const otherTitleMb = useMemo(
    () => (density === "tight" ? 0.5 : 1),
    [density],
  );
  const otherSectionPt = useMemo(
    () => (density === "tight" ? 1.75 : density === "compact" ? 2 : 2.5),
    [density],
  );

  const closeHoverMenu = () => {
    setHoverAnchor(null);
    setHoverChildren([]);
  };
  const handleMouseEnterItem = (event, children) => {
    cancelClose();
    if (!children?.length) {
      closeHoverMenu();
      return;
    }
    setHoverAnchor(event.currentTarget);
    setHoverChildren(children);
  };
  const handleMouseLeave = () => {
    hoverCloseTimeout = setTimeout(closeHoverMenu, 150);
  };
  const handleMouseEnterFlyout = () => cancelClose();

  const handleToggle = () => {
    if (onToggle) onToggle(!expanded);
    else setExpandedState((prev) => !prev);
    window.dispatchEvent(
      new Event(expanded ? "sidebar:collapse" : "sidebar:expand"),
    );
  };

  const toggleIcon = useMemo(
    () =>
      expanded ? (
        <ChevronLeftIcon sx={{ width: 20, height: 20, color: "#FEFEFE" }} />
      ) : (
        <ChevronRightIcon sx={{ width: 20, height: 20, color: "#FEFEFE" }} />
      ),
    [expanded],
  );

  const isActive = (path, children) => {
    if (location.pathname === "/" && path === "growth-plan") return true;
    if (!path && !children) return false;
    if (children?.length)
      return children.some((child) => location.pathname.includes(child.path));
    return location.pathname.includes(path);
  };

  const PathIcon = ({ d, active }) => (
    <Box
      component="img"
      src={d}
      alt=""
      sx={{
        width: 20,
        height: 20,
        filter: active ? "brightness(0) invert(1)" : "brightness(0.6)",
        transition: "filter 0.15s ease",
      }}
    />
  );

  const buildClientDashboardPath = (customerId, path) => {
    if (!customerId) return "/";
    return `/client/${customerId}/dashboard/${path}`;
  };

  const resolveNavPath = (path) => {
    if (!path) return undefined;
    if (path.startsWith("/")) return path;

    if (path === "settings" && staffView && newExperienceEnabled) {
      if (!isAdmin) return "/management/accounts";

      const rawCustomerId =
        clientRoute?.routeCustomerId || selectedCustomerId || null;
      const customerId =
        rawCustomerId &&
        rawCustomerId !== "null" &&
        rawCustomerId !== "undefined"
          ? rawCustomerId
          : null;

      return customerId
        ? buildClientDashboardPath(customerId, path)
        : "/management/accounts";
    }

    // Legacy staff have client/<id> paths in clientDetail, but not in here
    if (staffMode && !newExperienceEnabled) return `/${path}`;
    if (staffMode && newExperienceEnabled) {
      if (!effectiveCustomerId) return "/";
      return buildClientDashboardPath(effectiveCustomerId, path);
    }
    if (!staffMode && newExperienceEnabled) {
      // Client mode + new experience: some paths have special mappings to preserve old URLs
      if (path === "performance-overview") return "/performance";
      if (path === "scenario-planner") return "/scenario-planner";
    }
    return `/${path}`;
  };

  const isItemActive = (item, resolvedPath) => {
    if (location.pathname === "/" && item.path === "growth-plan") return true;
    if (!resolvedPath && !item.children?.length) return false;

    if (item.children?.length) {
      return item.children.some((child) =>
        location.pathname.includes(child.path),
      );
    }

    if (!resolvedPath) return false;
    return (
      location.pathname === resolvedPath ||
      location.pathname.startsWith(`${resolvedPath}/`)
    );
  };

  const renderItem = (item, customer) => {
    if (customer?.is_demo && item.path === "targets") return null;

    const resolvedPath = resolveNavPath(item.path);
    const active = isItemActive(item, resolvedPath);

    const isLink = Boolean(item.path);
    const listItemComponent = isLink ? RouterLink : "div";
    const listItemTo = isLink ? resolvedPath : undefined;

    const backgroundColor = active ? "rgba(76,99,215,1)" : "transparent";
    const hoverBackgroundColor = active
      ? "rgba(76,99,215,1)"
      : "rgba(255,255,255,0.05)";
    const iconFilter = active ? "brightness(0) invert(1)" : "brightness(0.6)";
    const textColor = active ? "#FEFEFE" : "#B3B9C6";

    return (
      <ListItem
        key={item.label}
        disableGutters
        component={listItemComponent}
        to={listItemTo}
        onMouseEnter={(e) => handleMouseEnterItem(e, item.children)}
        onMouseLeave={handleMouseLeave}
        sx={{
          width: expanded ? "100%" : 36,
          height: navItemHeight,
          minHeight: navItemHeight,
          py: 0,
          borderRadius: "8px",
          cursor: "pointer",
          mx: expanded ? 0 : "auto",
          px: navItemPx,
          display: "flex",
          alignItems: "center",
          justifyContent: expanded ? "flex-start" : "center",
          backgroundColor,

          "& .MuiListItemIcon-root": {
            minWidth: 0,
          },

          "& .MuiListItemIcon-root img": {
            transition: "filter 0.15s ease",
            filter: iconFilter,
          },

          "& .MuiListItemText-root .MuiTypography-root": {
            transition: "color 0.15s ease",
            color: textColor,
          },

          "&:hover": {
            backgroundColor: hoverBackgroundColor,
            "& .MuiListItemIcon-root img": {
              filter: "brightness(0) invert(1) !important",
            },
            "& .MuiListItemText-root .MuiTypography-root, & .MuiTypography-root":
              {
                color: "#FFFFFF !important",
              },
            "& svg": {
              color: "#FFFFFF !important",
              fill: "#FFFFFF !important",
            },
          },
        }}
      >
        <ListItemIcon sx={{ minWidth: 0, justifyContent: "center" }}>
          <PathIcon d={item.iconPath} active={active} />
        </ListItemIcon>

        {expanded && (
          <>
            <ListItemText
              primary={item.label}
              sx={{ ml: 1 }}
              primaryTypographyProps={{
                fontFamily: "'Rethink Sans', Helvetica, sans-serif",
                fontWeight: active ? 500 : 400,
                fontSize: 15,
                lineHeight: 1.6,
              }}
            />
            {item.children?.length > 0 && (
              <ChevronRightIcon
                sx={{
                  ml: "auto",
                  color: active ? "#FEFEFE" : "#B3B9C6",
                  width: 30,
                  height: 30,
                  transition: "color 0.15s ease",
                }}
              />
            )}
          </>
        )}
      </ListItem>
    );
  };

  const renderGroup = (group, customer) => {
    return (
      <Box key={group.title} sx={{ mb: groupMb }}>
        {expanded && (
          <Typography
            sx={{
              fontSize: groupTitleFontSize,
              color: "#8A94A6",
              fontWeight: 400,
              mb: groupTitleMb,
            }}
          >
            {group.title}
          </Typography>
        )}
        <List
          sx={{ p: 0, gap: groupGap, display: "flex", flexDirection: "column" }}
        >
          {group.items.map((item) => renderItem(item, customer))}
        </List>
      </Box>
    );
  };

  return (
    <>
      {/* When sidebar is collapsed on mobile, show a visible trigger to expand */}
      {isMobile && !expanded && (
        <Fab
          size="small"
          onClick={handleToggle}
          aria-label="Open menu"
          sx={{
            position: "fixed",
            left: 0,
            top: "50%",
            transform: "translateY(-50%)",
            zIndex: 1201,
            width: 32,
            height: 48,
            minHeight: 48,
            borderRadius: "0 8px 8px 0",
            bgcolor: "rgba(83,109,236,1)",
            boxShadow: "0px 0px 4.8px rgba(0,0,0,0.08)",
            "&:hover": { bgcolor: "rgba(76,99,215,1)" },
          }}
        >
          <ChevronRightIcon sx={{ width: 20, height: 20, color: "#FEFEFE" }} />
        </Fab>
      )}
      <Box
        sx={{
          width: expanded ? 300 : 95,
          transform:
            isMobile && !expanded ? "translateX(-100%)" : "translateX(0)",
          transition: "transform 0.25s ease, width 0.2s ease",
          flexShrink: 0,
          bgcolor: "#121621",
          color: "#F8FAFF",
          height: "100vh",
          display: "flex",
          flexDirection: "column",
          position: "fixed",
          top: 0,
          left: 0,
          zIndex: 1200,
        }}
      >
        {/* Logo */}
        <Box
          sx={{
            px: 2.5,
            pt: density === "tight" ? 2 : 2.5,
            pb: expanded ? (density === "tight" ? 1.5 : 2) : 3,
          }}
        >
          <Box
            component={RouterLink}
            to="/"
            sx={{
              display: "flex",
              width: expanded ? 130 : 56,
              height: expanded ? 28 : 56,
              alignItems: "center",
              justifyContent: "flex-start",
              textDecoration: "none",
            }}
          >
            <Box
              component="img"
              src={
                expanded
                  ? "/lucro-logo-white.png"
                  : "/collapsed-lucro-logo-icon.svg"
              }
              alt="Lucro"
              sx={{ width: "100%", height: "100%", objectFit: "contain" }}
            />
          </Box>
          {expanded &&
            ((staffMode && newExperienceEnabled) ||
              (profile?.type !== "admin" && !newExperienceEnabled)) && (
              <Box sx={{ mt: density === "tight" ? 2 : 3 }}>
                <SideBarAccountSelector
                  customers={customersForSelector}
                  profile={profile}
                  activeCustomer={activeCustomer}
                />
              </Box>
            )}
        </Box>

        <Box
          sx={{
            mx: 2.5,
            borderTop: "1px solid rgba(255,255,255,0.25)",
            position: "relative",
          }}
        />

        {/* Main Navigation */}
        <Box
          sx={{
            flex: 1,
            px: sectionPx,
            py: sectionPy,
            overflowY: "auto",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
          }}
        >
          <Box>
            {navGroups.map((group) =>
              renderGroup(group, activeCustomer),
            )}
          </Box>
          {/* Other */}
          <Box
            sx={{
              pt: otherSectionPt,
              borderTop: "1px solid rgba(255,255,255,0.25)",
            }}
          >
            {expanded && (
              <Typography
                sx={{
                  fontSize: groupTitleFontSize,
                  color: "#8A94A6",
                  fontWeight: 500,
                  mb: otherTitleMb,
                }}
              >
                Other
              </Typography>
            )}
            <List
              sx={{ p: 0, gap: 1, display: "flex", flexDirection: "column" }}
            >
              {OTHER_ITEMS.map((item) => {
                const resolvedPath =
                  item.label === "Go Back" && staffMode
                    ? goBackTarget
                    : item.path
                      ? resolveNavPath(item.path)
                      : undefined;

                const active =
                  item.label !== "Go Back" &&
                  resolvedPath &&
                  (location.pathname === resolvedPath ||
                    location.pathname.startsWith(`${resolvedPath}/`));
                return (
                  <ListItem
                    key={item.label}
                    component={RouterLink}
                    to={resolvedPath}
                    disableGutters
                    sx={{
                      width: expanded ? "100%" : 36,
                      height: navItemHeight,
                      minHeight: navItemHeight,
                      py: 0,
                      borderRadius: "8px",
                      cursor: "pointer",
                      mx: expanded ? 0 : "auto",
                      px: navItemPx,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: expanded ? "flex-start" : "center",
                      backgroundColor: active
                        ? "rgba(76,99,215,1)"
                        : "transparent",

                      "& .MuiTypography-root": {
                        color: active ? "#FFFFFF" : "#8A94A6",
                      },

                      "&:hover": {
                        backgroundColor: active
                          ? "rgba(76,99,215,1)"
                          : "rgba(255,255,255,0.05)",
                        "& .MuiListItemIcon-root img": {
                          filter: "brightness(0) invert(1) !important",
                        },
                        "& .MuiListItemText-root .MuiTypography-root, & .MuiTypography-root":
                          { color: "#FFFFFF !important" },
                        "& svg": {
                          color: "#FFFFFF !important",
                          fill: "#FFFFFF !important",
                        },
                      },
                    }}
                  >
                    <ListItemIcon
                      sx={{ minWidth: 0, justifyContent: "center" }}
                    >
                      <PathIcon d={item.iconPath} active={active} />
                    </ListItemIcon>
                    {expanded && (
                      <ListItemText
                        primary={item.label}
                        sx={{ ml: 1, color: "#8A94A6" }}
                        primaryTypographyProps={{
                          fontFamily: "'Rethink Sans', Helvetica, sans-serif",
                          fontWeight: active ? 500 : 400,
                          fontSize: 15,
                          lineHeight: 1.6,
                        }}
                      />
                    )}
                  </ListItem>
                );
              })}
            </List>

            {/* Toggle */}
            {!(isMobile && !expanded) && (
              <Fab
                size="small"
                onClick={handleToggle}
                sx={{
                  width: 32,
                  height: 32,
                  minHeight: 32,
                  position: "fixed",
                  left: expanded ? 300 - 16 : 94 - 16,
                  top: "96%",
                  transform: "translateY(-50%)",
                  bgcolor: "rgba(83,109,236,1)",
                  boxShadow: "0px 0px 4.8px rgba(0,0,0,0.08)",
                  "&:hover": { bgcolor: "rgba(76,99,215,1)" },
                  transition: "left 0.2s ease",
                }}
              >
                {toggleIcon}
              </Fab>
            )}
          </Box>
        </Box>

        {/* Hover Flyout */}
        <Popper
          open={Boolean(hoverAnchor)}
          anchorEl={hoverAnchor}
          placement="right-start"
          modifiers={[
            { name: "offset", options: { offset: [0, 32] } },
            {
              name: "preventOverflow",
              options: { padding: 8, boundary: "viewport" },
            },
            {
              name: "flip",
              enabled: true,
              options: {
                fallbackPlacements: [
                  "right-start",
                  "left-start",
                  "bottom-start",
                ],
                boundary: "viewport",
                padding: 8,
              },
            },
          ]}
          style={{ zIndex: 9999 }}
        >
          <Paper
            onMouseEnter={handleMouseEnterFlyout}
            onMouseLeave={handleMouseLeave}
            sx={{
              minWidth: 230,
              bgcolor: "#121621",
              borderRadius: "8px",
              overflow: "hidden",
              p: "12px 20px",
              boxShadow: "0px 4px 12px rgba(0,0,0,0.4)",
            }}
          >
            <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
              {hoverChildren.map((child) => {
                const active = isActive(child.path, child.children);
                return (
                  <Box
                    key={child.label}
                    component={RouterLink}
                    to={`/${child.path}`}
                    onMouseEnter={cancelClose}
                    onMouseLeave={handleMouseLeave}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 1.5,
                      minHeight: 44,
                      py: 1,
                      px: 2,
                      borderRadius: "8px",
                      cursor: "pointer",
                      textDecoration: "none",
                      backgroundColor: active
                        ? "rgba(76,99,215,1)"
                        : "transparent",
                      color: active ? "#FFFFFF" : "#B3B9C6",
                      transition: "all 0.15s ease",
                      "&:hover": {
                        backgroundColor: active
                          ? "rgba(76,99,215,1)"
                          : "rgba(255,255,255,0.05)",
                        color: "#FFFFFF",
                        "& img": {
                          filter: "brightness(0) invert(1) !important",
                        },
                        "& svg": {
                          color: "#FFFFFF !important",
                          fill: "#FFFFFF !important",
                        },
                      },
                    }}
                  >
                    <Box
                      component="img"
                      src={child.iconPath}
                      alt=""
                      sx={{
                        width: 20,
                        height: 20,
                        filter: active
                          ? "brightness(0) invert(1)"
                          : "brightness(0.6)",
                        transition: "filter 0.15s ease",
                      }}
                    />
                    <Typography
                      sx={{
                        fontSize: 15,
                        fontFamily: "'Rethink Sans', Helvetica, sans-serif",
                        fontWeight: active ? 500 : 400,
                      }}
                    >
                      {child.label}
                    </Typography>
                  </Box>
                );
              })}
            </Box>
          </Paper>
        </Popper>
      </Box>
    </>
  );
};

export default Sidebar;
